module.exports = __webpack_public_path__ + "18a30654d5e9941c6b9f72a6c21c4265.svg";